export default __webpack_public_path__ + "static/media/notificacoes.49a86742.png";